"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9612],{

/***/ 15695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34855);
/* harmony import */ var _Trigger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12830);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32393);
/* harmony import */ var _util_pick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9472);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92833);
/* harmony import */ var _util_is__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53367);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







var defaultProps = {
    position: 'top',
    trigger: 'hover',
    escToClose: false,
    unmountOnExit: true,
    blurToHide: true,
    popupHoverStay: true,
};
var triggerDuration = {
    enter: 300,
    exit: 100,
};
var triggerPopupAlign = {
    left: 12,
    right: 12,
    top: 12,
    bottom: 12,
};
function Tooltip(baseProps, ref) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_), getPrefixCls = _a.getPrefixCls, componentConfig = _a.componentConfig;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Tooltip);
    var style = props.style, className = props.className, children = props.children, trigger = props.trigger, escToClose = props.escToClose, defaultPopupVisible = props.defaultPopupVisible, position = props.position, unmountOnExit = props.unmountOnExit, popupVisible = props.popupVisible, tooltipPrefixCls = props.prefixCls, blurToHide = props.blurToHide, popupHoverStay = props.popupHoverStay, disabled = props.disabled, onVisibleChange = props.onVisibleChange, triggerProps = props.triggerProps, childrenPrefix = props.childrenPrefix, getPopupContainer = props.getPopupContainer, content = props.content, mini = props.mini, color = props.color, rest = __rest(props, ["style", "className", "children", "trigger", "escToClose", "defaultPopupVisible", "position", "unmountOnExit", "popupVisible", "prefixCls", "blurToHide", "popupHoverStay", "disabled", "onVisibleChange", "triggerProps", "childrenPrefix", "getPopupContainer", "content", "mini", "color"]);
    var refTrigger = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var updatePopupPosition = function (delay, callback) {
        if (delay === void 0) { delay = 0; }
        refTrigger.current && refTrigger.current.updatePopupPosition(delay, callback);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () { return ({
        updatePopupPosition: updatePopupPosition,
    }); }, []);
    var prefixCls = tooltipPrefixCls || getPrefixCls('tooltip');
    var otherProps = __assign(__assign(__assign({}, (0,_util_pick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rest, _Trigger__WEBPACK_IMPORTED_MODULE_4__/* .EventsByTriggerNeed */ .C)), (0,_util_pick__WEBPACK_IMPORTED_MODULE_3__/* .pickDataAttributes */ .m)(rest)), triggerProps);
    var renderedContent = (0,_util_is__WEBPACK_IMPORTED_MODULE_5__/* .isFunction */ .mf)(content) ? content() : content;
    // it is important to note that this method has its limitations
    // it fails in cases such as content = <>&nbsp;&nbsp;</>
    var isEmpty = function (content) {
        if (content === null || content === undefined || content === false) {
            return true;
        }
        if (typeof content === 'string' && content.trim() === '') {
            return true;
        }
        return false;
    };
    if ('popupVisible' in props) {
        otherProps.popupVisible = popupVisible;
    }
    else if (isEmpty(renderedContent)) {
        // hide if empty content
        otherProps.popupVisible = false;
    }
    if (otherProps.showArrow !== false || otherProps.arrowProps) {
        otherProps.arrowProps = otherProps.arrowProps || {};
        if (color) {
            otherProps.arrowProps.style = __assign({ backgroundColor: color }, otherProps.arrowProps.style);
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Trigger__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, __assign({ style: __assign({ maxWidth: 350 }, style), className: className, ref: refTrigger, classNames: "zoomInFadeOut", duration: triggerDuration, popup: function () {
            var _a;
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { style: { backgroundColor: color }, className: (0,_util_classNames__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(prefixCls + "-content", prefixCls + "-content-" + position, (_a = {},
                    _a[prefixCls + "-mini"] = mini,
                    _a)), role: "tooltip" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: prefixCls + "-content-inner" }, renderedContent)));
        }, position: position, disabled: disabled, trigger: trigger, escToClose: escToClose, showArrow: true, popupAlign: triggerPopupAlign, mouseEnterDelay: 200, mouseLeaveDelay: 200, unmountOnExit: unmountOnExit, popupHoverStay: popupHoverStay, blurToHide: blurToHide, childrenPrefix: childrenPrefix || prefixCls, getPopupContainer: getPopupContainer, onVisibleChange: onVisibleChange, defaultPopupVisible: defaultPopupVisible }, otherProps), children));
}
var TooltipComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Tooltip);
TooltipComponent.displayName = 'Tooltip';
/* harmony default export */ __webpack_exports__["Z"] = (TooltipComponent);


/***/ }),

/***/ 12830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ EventsByTriggerNeed; },
  "Z": function() { return /* binding */ es_Trigger; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__(91033);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsFirstRender.js
var useIsFirstRender = __webpack_require__(91626);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Trigger/portal.js
// only used by trigger. Plan to replace ../Portal




var Portal = function (props) {
    var getContainer = props.getContainer, children = props.children;
    var containerRef = (0,react.useRef)();
    var isFirstRender = (0,useIsFirstRender/* default */.Z)();
    if ((isFirstRender || containerRef.current === null) && !dom/* isServerRendering */.ET) {
        containerRef.current = getContainer();
    }
    (0,react.useEffect)(function () {
        return function () {
            var container = containerRef.current;
            if (container && container.parentNode) {
                container.parentNode.removeChild(container);
                containerRef.current = null;
            }
        };
    }, []);
    return containerRef.current ? react_dom.createPortal(children, containerRef.current) : null;
};
/* harmony default export */ var Trigger_portal = (Portal);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Trigger/getPopupStyle.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


// get element's position relative to root element
function getElementPosition(element, elementRect, root) {
    if (!root || !element || dom/* isServerRendering */.ET) {
        return { left: 0, width: 0, height: 0, top: 0 };
    }
    // safari and chrome
    var bodyScroll = function (direction) { return document.documentElement[direction] || document.body[direction]; };
    var pageScrollTop = root === document.body ? bodyScroll('scrollTop') : root.scrollTop;
    var pageScrollLeft = root === document.body ? bodyScroll('scrollLeft') : root.scrollLeft;
    var left = elementRect.left, top = elementRect.top, width = elementRect.width, height = elementRect.height;
    // custom container
    var rootLeft = root === document.body ? 0 : root.getBoundingClientRect().left;
    var rootTop = root === document.body ? 0 : root.getBoundingClientRect().top;
    var pTop = top + pageScrollTop - rootTop;
    var pLeft = left + pageScrollLeft - rootLeft;
    return {
        left: pLeft,
        top: pTop,
        width: width,
        height: height,
    };
}
var getInsideValue = function (min, max, value) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
var getPopupAlign = function (propsPopupAlign, showArrow) {
    var horizontalOffset = 0;
    var verticalOffset = 0;
    var resultPopupAlign = {};
    if (!showArrow) {
        resultPopupAlign = __assign({}, propsPopupAlign);
    }
    else {
        resultPopupAlign = __assign({ left: 12, right: 12, top: 12, bottom: 12 }, propsPopupAlign);
    }
    for (var key in resultPopupAlign) {
        if ((0,is/* isArray */.kJ)(resultPopupAlign[key])) {
            var index = 0;
            // top,bottom 时候，第二个参数是纵向偏移量
            if (['top', 'bottom'].indexOf(key) > -1) {
                index = 1;
                horizontalOffset = resultPopupAlign[key][0];
            }
            else {
                verticalOffset = resultPopupAlign[key][1];
            }
            resultPopupAlign[key] = resultPopupAlign[key][index];
        }
    }
    return __assign(__assign({}, resultPopupAlign), { horizontalOffset: horizontalOffset, verticalOffset: verticalOffset });
};
var getChildRect = function (child, mouseLocation) {
    return mouseLocation
        ? {
            left: mouseLocation.clientX,
            top: mouseLocation.clientY,
            width: 0,
            height: 0,
            right: mouseLocation.clientX,
            bottom: mouseLocation.clientY,
        }
        : child.getBoundingClientRect();
};
// popup 弹出层的尺寸。 https://github.com/arco-design/arco-design/issues/2132
var getContentSize = function (content) {
    var width = content.offsetWidth;
    var height = content.offsetHeight;
    return {
        width: width,
        height: height,
    };
};
/* harmony default export */ var getPopupStyle = (function (props, content, child, mountContainer, mouseLocation) {
    var autoAlignPopupWidth = props.autoAlignPopupWidth, autoAlignPopupMinWidth = props.autoAlignPopupMinWidth, alignPoint = props.alignPoint, propsStyle = props.style;
    if (!child || !content || !mountContainer) {
        return {};
    }
    var style = {};
    // 如果跟随鼠标，相当于鼠标位置作为 child
    var childRect = getChildRect(child, alignPoint && mouseLocation);
    var _a = getElementPosition(child, childRect, mountContainer), left = _a.left, top = _a.top, width = _a.width, height = _a.height;
    var popupAlign = getPopupAlign(props.popupAlign, props.showArrow);
    var alignLeft = popupAlign.left || 0;
    var alignRight = popupAlign.right || 0;
    var alignTop = popupAlign.top || 0;
    var alignBottom = popupAlign.bottom || 0;
    // 通过props.style 传递的width优先级更高
    if (autoAlignPopupWidth && (propsStyle === null || propsStyle === void 0 ? void 0 : propsStyle.width) === undefined) {
        content.style.width = child.offsetWidth + "px";
    }
    if (autoAlignPopupMinWidth) {
        content.style.minWidth = child.offsetWidth + "px";
    }
    var contentSize = getContentSize(content);
    var realPosition = props.position;
    var arrowStyle = {};
    var autoPosition = function (direction) {
        var _a, _b;
        if (!props.autoFitPosition) {
            return;
        }
        // document.documentElement?.clientHeight 是为了排除横向滚动条的高度影响。
        var windowHeight = ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) || window.innerHeight;
        var windowWidth = ((_b = document.documentElement) === null || _b === void 0 ? void 0 : _b.clientWidth) || window.innerWidth;
        var result = false; // 是否进行了位置调整
        // 视口左侧/顶部到 popupContainer 的距离
        var boundary = {
            left: left - childRect.left,
            top: top - childRect.top,
        };
        var _c = style.top, styleTop = _c === void 0 ? 0 : _c, _d = style.left, styleLeft = _d === void 0 ? 0 : _d;
        // 水平方向微调
        if (direction === 'top' || direction === 'bottom') {
            if (boundary.left > styleLeft && childRect.right > 12) {
                // 左边被遮挡
                style.left = Math.max(boundary.left, left - contentSize.width);
                style.left = Math.max(style.left, left - contentSize.width + 24);
            }
            else if (styleLeft - boundary.left + contentSize.width > windowWidth &&
                windowWidth - childRect.left > 12) {
                // 右侧被遮挡，右侧贴边。如果child在可视区内的宽度小于12，不进行位置调整
                style.left = Math.max(boundary.left, boundary.left + windowWidth - contentSize.width);
                style.left = Math.max(style.left, left - contentSize.width + 24);
            }
        }
        // 垂直方向微调
        if (direction === 'left' || direction === 'right') {
            if (boundary.top > styleTop && childRect.bottom > 12) {
                // 上面
                style.top = boundary.top;
                style.top = Math.max(style.top, top - contentSize.height + childRect.height / 2);
            }
            else if (styleTop - boundary.top + contentSize.height > windowHeight &&
                windowHeight - childRect.top > 12) {
                // 向上微调位置，如果child在可视区内的高度小于12，不进行位置调整
                style.top = Math.max(boundary.top, boundary.top + windowHeight - contentSize.height);
                style.top = Math.max(style.top, top - contentSize.height + childRect.height / 2);
            }
        }
        if (direction === 'top' && boundary.top > styleTop) {
            // 上面被遮挡
            if (childRect.top < windowHeight - childRect.bottom) {
                // 放到下面
                style.top = Math.min(top + height + (alignTop || 0), boundary.top + windowHeight - contentSize.height);
                result = true;
            }
            else {
                // 贴顶部边界
                style.top = boundary.top;
            }
        }
        if (direction === 'bottom' && styleTop - boundary.top + contentSize.height > windowHeight) {
            // 下部分被遮挡
            if (windowHeight - childRect.bottom < childRect.top) {
                // 放到上面
                style.top = Math.max(top - contentSize.height - (alignBottom || 0), boundary.top);
                result = true;
            }
            else {
                // 贴底边界
                style.top = boundary.top + windowHeight - contentSize.height;
            }
        }
        if (direction === 'left' && boundary.left > styleLeft) {
            // 左边被遮挡
            if (childRect.left < windowWidth - childRect.right) {
                // 放到右边
                style.left = Math.min(width + left + alignRight, boundary.left + windowWidth - contentSize.width);
                result = true;
            }
            else {
                style.left = boundary.left;
            }
        }
        if (direction === 'right' && styleLeft - boundary.left + contentSize.width > windowWidth) {
            // 右边被遮挡
            if (windowWidth - childRect.right < childRect.left) {
                // 放到左边
                style.left = Math.max(left - contentSize.width - alignLeft, boundary.left);
                result = true;
            }
            else {
                // 贴左边界
                style.left = boundary.left + windowWidth - contentSize.width;
            }
        }
        // 限制在popupContainer中，左侧最小为 0px
        if (style.left < 0) {
            style.left = 0;
        }
        else {
            // 限制在popupContainer中，左侧最大为 mountContainer.scrollWidth - contentSize.width，保证弹出层在container内部
            var maxLeft = mountContainer.scrollWidth - contentSize.width;
            style.left = Math.min(maxLeft, style.left);
        }
        return result;
    };
    var horizontalOffset = popupAlign.horizontalOffset || 0;
    var verticalOffset = popupAlign.verticalOffset || 0;
    switch (props.position) {
        case 'top': {
            style.top = top - contentSize.height - alignTop;
            style.left = left + width / 2 - contentSize.width / 2;
            autoPosition('top') && (realPosition = 'bottom');
            style.left += horizontalOffset;
            var arrowLeft_1 = left - Number(style.left) + width / 2;
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft_1);
            break;
        }
        case 'tl':
            style.top = top - contentSize.height - alignTop;
            style.left = left;
            autoPosition('top') && (realPosition = 'bl');
            style.left += horizontalOffset;
            var arrowLeft = left - Number(style.left) + Math.min(width / 2, 50);
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft);
            break;
        case 'tr':
            style.top = -content.clientHeight + top - alignTop;
            style.left = left + width - contentSize.width;
            autoPosition('top') && (realPosition = 'br');
            style.left += horizontalOffset;
            arrowLeft = left - Number(style.left) + Math.max(width / 2, width - 50);
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft);
            break;
        case 'bottom': {
            style.top = height + top + alignBottom;
            style.left = left + width / 2 - contentSize.width / 2;
            autoPosition('bottom') && (realPosition = 'top');
            style.left += horizontalOffset;
            var arrowLeft_2 = left - Number(style.left) + width / 2;
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft_2);
            break;
        }
        case 'bl':
            style.top = height + top + alignBottom;
            style.left = left;
            autoPosition('bottom') && (realPosition = 'tl');
            style.left += horizontalOffset;
            arrowLeft = left - Number(style.left) + Math.min(width / 2, 50);
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft);
            break;
        case 'br':
            style.top = height + top + alignBottom;
            style.left = left + width - contentSize.width;
            autoPosition('bottom') && (realPosition = 'tr');
            style.left += horizontalOffset;
            arrowLeft = left - Number(style.left) + Math.max(width / 2, width - 50);
            arrowStyle.left = getInsideValue(12, contentSize.width - 12, arrowLeft);
            break;
        case 'left': {
            style.top = top + height / 2 - contentSize.height / 2;
            style.left = left - contentSize.width - alignLeft;
            autoPosition('left') && (realPosition = 'right');
            style.top += verticalOffset;
            var arrowTop_1 = top - Number(style.top) + height / 2;
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop_1);
            break;
        }
        case 'lt':
            style.top = top;
            style.left = left - contentSize.width - alignLeft;
            autoPosition('left') && (realPosition = 'rt');
            style.top += verticalOffset;
            var arrowTop = top - Number(style.top) + Math.min(height / 2, 50);
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop);
            break;
        case 'lb':
            style.top = top + height - contentSize.height;
            style.left = left - contentSize.width - alignLeft;
            autoPosition('left') && (realPosition = 'rb');
            style.top += verticalOffset;
            arrowTop = top - Number(style.top) + Math.max(height / 2, height - 50);
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop);
            break;
        case 'right': {
            style.top = top + height / 2 - contentSize.height / 2;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'left');
            style.top += verticalOffset;
            var arrowTop_2 = top - Number(style.top) + height / 2;
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop_2);
            break;
        }
        case 'rt':
            style.top = top;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'lt');
            style.top += verticalOffset;
            arrowTop = top - Number(style.top) + Math.min(height / 2, 50);
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop);
            break;
        case 'rb':
            style.top = top + height - contentSize.height;
            style.left = width + left + alignRight;
            autoPosition('right') && (realPosition = 'lb');
            style.top += verticalOffset;
            arrowTop = top - Number(style.top) + Math.max(height / 2, height - 50);
            arrowStyle.top = getInsideValue(12, contentSize.height - 12, arrowTop);
            break;
        default:
            break;
    }
    return {
        style: style,
        arrowStyle: arrowStyle,
        realPosition: realPosition,
    };
});

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/throttleByRaf.js
var throttleByRaf = __webpack_require__(40694);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/raf.js
var raf = __webpack_require__(44734);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/mergeProps.js
var mergeProps = __webpack_require__(38779);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Trigger/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Trigger_assign = (undefined && undefined.__assign) || function () {
    Trigger_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Trigger_assign.apply(this, arguments);
};
















function getDOMPos(dom) {
    if (!dom) {
        return {};
    }
    var _a = dom.getBoundingClientRect(), width = _a.width, height = _a.height, left = _a.left, right = _a.right;
    return {
        width: width,
        height: height,
        left: left,
        right: right,
    };
}
var EventsByTriggerNeed = [
    'onClick',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onFocus',
    'onBlur',
    'onContextMenu',
    'onKeyDown',
];
function splitChildrenStyle(obj, keys) {
    var picked = {};
    var omitted = Trigger_assign({}, obj);
    keys.forEach(function (key) {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete omitted[key];
        }
    });
    return { picked: picked, omitted: omitted };
}
var defaultProps = {
    blurToHide: true,
    // clickToClose: true,
    classNames: 'fadeIn',
    trigger: 'hover',
    position: 'bottom',
    duration: 200,
    unmountOnExit: true,
    popupAlign: {},
    popupHoverStay: true,
    clickOutsideToClose: true,
    escToClose: false,
    mouseLeaveToClose: true,
    containerScrollToClose: false,
    getDocument: function () { return window.document; },
    autoFixPosition: true,
    mouseEnterDelay: 100,
    mouseLeaveDelay: 100,
    autoFitPosition: true,
};
var Trigger = /** @class */ (function (_super) {
    __extends(Trigger, _super);
    function Trigger(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.delayTimer = null;
        _this.updatePositionTimer = null;
        // is popup open?
        _this.popupOpen = false;
        // if mousedown to hide popup, ignore onFocus
        _this.mousedownToHide = false;
        _this.hasPopupMouseDown = false;
        _this.unmount = false;
        _this.isDidMount = false;
        // 保存鼠标的位置
        _this.mouseLocation = {
            clientX: 0,
            clientY: 0,
        };
        // 保存当前的mount container dom元素
        _this.observerContainer = null;
        // 保存当前节点到 popupContainer 间的所有滚动元素
        _this.scrollElements = null;
        // container 触发 resize时执行
        _this.resizeObserver = new ResizeObserver_es/* default */.Z(function () {
            _this.handleUpdatePosition();
        });
        _this.childrenDom = null;
        // 保存children节点的尺寸。 主要用于在弹出层动画前和动画完成后比较尺寸是否有变化。
        _this.childrenDomSize = {};
        _this.getMergedProps = function (baseProps) {
            var componentConfig = _this.context.componentConfig;
            var props = (0,mergeProps/* default */.Z)(baseProps || _this.props, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Trigger);
            return props;
        };
        _this.getRootElement = function () {
            _this.childrenDom = (0,react_dom.findDOMNode)(_this);
            return _this.childrenDom;
        };
        _this.offScrollListeners = function () {
            (_this.scrollElements || []).forEach(function (item) {
                (0,dom/* off */.S1)(item, 'scroll', _this.handleScroll);
            });
            _this.scrollElements = null;
        };
        _this.offWindowResize = function () {
            _this.handleWindowResize = false;
            (0,dom/* off */.S1)(window, 'resize', _this.handleUpdatePosition);
        };
        _this.offContainerResize = function () {
            if (_this.resizeObserver && _this.observerContainer) {
                _this.resizeObserver.unobserve(_this.observerContainer);
                _this.observerContainer = null;
            }
        };
        _this.handleScroll = function () {
            var currentProps = _this.getMergedProps();
            if (currentProps.containerScrollToClose) {
                _this.setPopupVisible(false);
            }
            else if (currentProps.updateOnScroll) {
                _this.handleUpdatePosition();
            }
        };
        _this.onContainersScroll = function (props) {
            var _a, _b;
            if (_this.scrollElements) {
                return;
            }
            _this.scrollElements = (0,dom/* getScrollElements */.IF)(_this.childrenDom, (_a = _this.popupContainer) === null || _a === void 0 ? void 0 : _a.parentNode);
            // 弹出层挂载载 body 且 body 不是滚动元素时，需要额外检测 document.documentElement 是否是滚动元素
            // 默认 html,body 不限制宽高时，滚动事件仅能在 window 上监听
            // fix: https://github.com/arco-design/arco-design/issues/1599
            if (props.containerScrollToClose &&
                ((_b = _this.popupContainer) === null || _b === void 0 ? void 0 : _b.parentNode) === document.body &&
                _this.scrollElements.indexOf(document.body) === -1 &&
                (0,dom/* isScrollElement */.Ib)(document.documentElement)) {
                _this.scrollElements.push(window);
            }
            _this.scrollElements.forEach(function (item) {
                (0,dom.on)(item, 'scroll', _this.handleScroll);
            });
        };
        _this.onContainerResize = function () {
            var _a;
            // containerParent 相当于是通过getPopupContainer传入的节点
            // 因为 this.popupContainer 会被挂载到getPopupContainer返回的节点上
            var containerParent = (_a = _this.popupContainer) === null || _a === void 0 ? void 0 : _a.parentNode;
            if (_this.resizeObserver && _this.observerContainer !== containerParent) {
                // 说明containerParent变了，取消之前的监听，监听新的container
                _this.offContainerResize();
                containerParent && _this.resizeObserver.observe(containerParent);
                _this.observerContainer = containerParent;
            }
        };
        // getPopupContainer 改变时候触发
        _this.handleUpdatePosition = (0,throttleByRaf/* default */.Z)(function () {
            _this.updatePopupPosition();
        });
        _this.isClickTrigger = function () {
            var trigger = _this.getMergedProps().trigger;
            return [].concat(trigger).indexOf('click') > -1;
        };
        _this.isFocusTrigger = function () {
            var trigger = _this.getMergedProps().trigger;
            return [].concat(trigger).indexOf('focus') > -1;
        };
        _this.isHoverTrigger = function () {
            var trigger = _this.getMergedProps().trigger;
            return [].concat(trigger).indexOf('hover') > -1;
        };
        _this.isContextMenuTrigger = function () {
            var trigger = _this.getMergedProps().trigger;
            return [].concat(trigger).indexOf('contextMenu') > -1;
        };
        // 是否在鼠标移出触发节点和popup的时候隐藏弹出层
        _this.isMouseLeaveToClose = function () {
            return _this.isHoverTrigger() && _this.getMergedProps().mouseLeaveToClose;
        };
        // 是否在悬浮到popup的时候隐藏弹出层
        _this.isPopupHoverHide = function () {
            return _this.isHoverTrigger() && !_this.getMergedProps().popupHoverStay;
        };
        _this.isClickToHide = function () {
            if (_this.isClickTrigger() || _this.isContextMenuTrigger()) {
                var _a = _this.getMergedProps().clickToClose, clickToClose = _a === void 0 ? true : _a;
                return clickToClose;
            }
            // 2.44.0 及之前版本 clickToClose 对 hover触发不生效。
            // 2.44.1 之后只有在props直接传入clickToClose 时才生效于 hover 触发方式，避免如以下用法前后表现不一致
            // <Trigger><Trigger trigger="click"><button>sss</button></a></Trigger></Trigger>
            return _this.isHoverTrigger() && _this.props.clickToClose;
        };
        _this.isBlurToHide = function () {
            return _this.isFocusTrigger() && _this.getMergedProps().blurToHide;
        };
        _this.clearTimer = function () {
            if (_this.updatePositionTimer) {
                if (_this.updatePositionTimer.cancel) {
                    _this.updatePositionTimer.cancel();
                }
                else {
                    clearTimeout(_this.updatePositionTimer);
                    _this.updatePositionTimer = null;
                }
            }
            if (_this.delayTimer) {
                clearTimeout(_this.delayTimer);
                _this.delayTimer = null;
            }
            if (_this.mouseDownTimeout) {
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = null;
            }
        };
        _this.offClickOutside = function () {
            if (_this.handleClickOutside) {
                var getDocument = _this.getMergedProps().getDocument;
                var root = (0,is/* isFunction */.mf)(getDocument) && getDocument();
                (0,dom/* off */.S1)(root, 'mousedown', _this.onClickOutside);
                _this.handleClickOutside = false;
            }
        };
        _this.getTransformOrigin = function (position) {
            var _a, _b;
            var content = _this.triggerRef;
            if (!content)
                return {};
            var _c = _this.getMergedProps(), showArrow = _c.showArrow, classNames = _c.classNames;
            var top = (showArrow && ((_a = _this.arrowStyle) === null || _a === void 0 ? void 0 : _a.top)) || 0;
            var left = (showArrow && ((_b = _this.arrowStyle) === null || _b === void 0 ? void 0 : _b.left)) || 0;
            top = top ? top + "px" : '';
            left = left ? left + "px" : '';
            var transformOrigin = {
                top: (left || '50%') + " 100% 0",
                tl: (left || '15px') + " 100% 0",
                tr: (left || content.clientWidth - 15 + "px") + " 100% 0",
                bottom: (left || '50%') + " 0 0",
                bl: (left || '15px') + " 0 0",
                br: (left || content.clientWidth - 15 + "px") + " 0 0",
                left: "100% " + (top || '50%') + " 0",
                lt: "100% " + (top || '15px') + " 0",
                lb: "100% " + (top || content.clientHeight - 15 + "px") + " 0",
                right: "0 " + (top || '50%') + " 0",
                rt: "0 " + (top || '15px') + " 0",
                rb: "0 " + (top || content.clientHeight - 15 + "px") + " 0",
            };
            // tooltip popover popconfirm
            if (classNames && classNames.indexOf('zoom') > -1) {
                return {
                    transformOrigin: transformOrigin[position],
                };
            }
            if (classNames === 'slideDynamicOrigin') {
                var origin_1 = '0% 0%';
                if (['top', 'tl', 'tr'].indexOf(position) > -1) {
                    origin_1 = '100% 100%';
                }
                return {
                    transformOrigin: origin_1,
                };
            }
            return {};
        };
        // 下拉框存在初始translateY/translateX，需要根据真实的弹出位置确定
        _this.getTransformTranslate = function () {
            if (_this.getMergedProps().classNames !== 'slideDynamicOrigin') {
                return '';
            }
            switch (_this.realPosition) {
                case 'bottom':
                case 'bl':
                case 'br':
                    return 'scaleY(0.9) translateY(-4px)';
                case 'top':
                case 'tl':
                case 'tr':
                    return 'scaleY(0.9) translateY(4px)';
                default:
                    return '';
            }
        };
        _this.getPopupStyle = function () {
            if (_this.unmount || !_this.popupContainer) {
                return;
            }
            var mountContainer = _this.popupContainer;
            var content = _this.triggerRef;
            var child = _this.getRootElement();
            // offsetParent=null when display:none or position: fixed
            if (!child.offsetParent && !child.getClientRects().length) {
                return _this.state.popupStyle;
            }
            var _a = getPopupStyle(_this.getMergedProps(), content, child, mountContainer, _this.mouseLocation), style = _a.style, arrowStyle = _a.arrowStyle, realPosition = _a.realPosition;
            _this.realPosition = realPosition || _this.getMergedProps().position;
            _this.arrowStyle = arrowStyle || {};
            return Trigger_assign(Trigger_assign({}, style), _this.getTransformOrigin(_this.realPosition));
        };
        _this.showPopup = function (callback) {
            if (callback === void 0) { callback = function () { }; }
            var popupStyle = _this.getPopupStyle();
            _this.setState({
                popupStyle: popupStyle,
            }, callback);
        };
        _this.update = (0,throttleByRaf/* default */.Z)(function (callback) {
            if (_this.unmount || !_this.state.popupVisible) {
                return;
            }
            var popupStyle = _this.getPopupStyle();
            _this.setState({
                popupStyle: popupStyle,
            }, function () {
                callback && callback();
            });
        });
        _this.updatePopupPosition = function (delay, callback) {
            if (delay === void 0) { delay = 0; }
            var currentVisible = _this.state.popupVisible;
            if (!currentVisible) {
                return;
            }
            if (delay < 4) {
                _this.updatePositionTimer = _this.update(callback);
                return;
            }
            _this.updatePositionTimer = setTimeout(function () {
                var popupStyle = _this.getPopupStyle();
                _this.setState({
                    popupStyle: popupStyle,
                }, function () {
                    callback && callback();
                });
            }, delay);
        };
        _this.setPopupVisible = function (visible, delay, callback) {
            if (delay === void 0) { delay = 0; }
            var mergedProps = _this.getMergedProps();
            var onVisibleChange = mergedProps.onVisibleChange;
            var currentVisible = _this.state.popupVisible;
            if (visible !== currentVisible) {
                _this.delayToDo(delay, function () {
                    onVisibleChange && onVisibleChange(visible);
                    if (!('popupVisible' in mergedProps)) {
                        if (visible) {
                            _this.setState({
                                popupVisible: true,
                            }, function () {
                                _this.showPopup(callback);
                            });
                        }
                        else {
                            _this.setState({
                                popupVisible: false,
                            }, function () {
                                callback && callback();
                            });
                        }
                    }
                    else {
                        callback && callback();
                    }
                });
            }
            else {
                callback && callback();
            }
        };
        _this.delayToDo = function (delay, callback) {
            if (delay) {
                _this.clearDelayTimer();
                _this.delayTimer = setTimeout(function () {
                    callback();
                    _this.clearDelayTimer();
                }, delay);
            }
            else {
                callback();
            }
        };
        // 点击非popup内部，非children内部的节点，触发clickoutside 逻辑
        _this.onClickOutside = function (e) {
            var _a = _this.getMergedProps(), onClickOutside = _a.onClickOutside, clickOutsideToClose = _a.clickOutsideToClose;
            var triggerNode = _this.triggerRef;
            var childrenDom = _this.getRootElement();
            if (!(0,dom/* contains */.r3)(triggerNode, e.target) &&
                !(0,dom/* contains */.r3)(childrenDom, e.target) &&
                !_this.hasPopupMouseDown) {
                onClickOutside && onClickOutside();
                if (clickOutsideToClose) {
                    // 以下判断条件避免onVisibleChange触发两次
                    // blurToHide 为true时不需要执行，因为onBlur里会执行setPopupVisible
                    // hover 触发方式，不执行以下逻辑。因为mouseLeave里会执行setPopupVisible
                    if (!_this.isBlurToHide() && !_this.isHoverTrigger()) {
                        _this.setPopupVisible(false);
                    }
                }
            }
        };
        _this.onKeyDown = function (e) {
            var keyCode = e.keyCode || e.which;
            _this.triggerPropsEvent('onKeyDown', e);
            if (keyCode === keycode/* Esc.code */.AV.code) {
                _this.onPressEsc(e);
            }
        };
        _this.onPressEsc = function (e) {
            var escToClose = _this.getMergedProps().escToClose;
            if (escToClose && e && e.key === keycode/* Esc.key */.AV.key && _this.state.popupVisible) {
                _this.setPopupVisible(false);
            }
        };
        _this.onMouseEnter = function (e) {
            var mouseEnterDelay = _this.getMergedProps().mouseEnterDelay;
            _this.triggerPropsEvent('onMouseEnter', e);
            _this.clearDelayTimer();
            _this.setPopupVisible(true, mouseEnterDelay || 0);
        };
        _this.onMouseMove = function (e) {
            _this.triggerPropsEvent('onMouseMove', e);
            _this.setMouseLocation(e);
            if (_this.state.popupVisible) {
                _this.update();
            }
        };
        _this.onMouseLeave = function (e) {
            var mouseLeaveDelay = _this.getMergedProps().mouseLeaveDelay;
            _this.clearDelayTimer();
            _this.triggerPropsEvent('onMouseLeave', e);
            if (_this.isMouseLeaveToClose()) {
                if (_this.state.popupVisible) {
                    _this.setPopupVisible(false, mouseLeaveDelay || 0);
                }
            }
        };
        _this.onPopupMouseEnter = function () {
            _this.clearDelayTimer();
        };
        _this.onPopupMouseLeave = function (e) {
            _this.onMouseLeave(e);
        };
        _this.setMouseLocation = function (e) {
            if (_this.getMergedProps().alignPoint) {
                _this.mouseLocation = {
                    clientX: e.clientX,
                    clientY: e.clientY,
                };
            }
        };
        _this.onContextMenu = function (e) {
            e.preventDefault();
            _this.triggerPropsEvent('onContextMenu', e);
            _this.setMouseLocation(e);
            if (!_this.state.popupVisible) {
                _this.setPopupVisible(true, 0);
            }
            else {
                // 更新位置
                _this.getMergedProps().alignPoint && _this.update();
            }
        };
        _this.clickToHidePopup = function (e) {
            var popupVisible = _this.state.popupVisible;
            if (popupVisible) {
                _this.mousedownToHide = true;
            }
            _this.triggerPropsEvent('onClick', e);
            if (_this.isClickToHide() && popupVisible) {
                _this.setPopupVisible(!popupVisible, 0);
            }
        };
        _this.onClick = function (e) {
            var popupVisible = _this.state.popupVisible;
            if (popupVisible) {
                _this.mousedownToHide = true;
            }
            _this.triggerPropsEvent('onClick', e);
            _this.setMouseLocation(e);
            if (!_this.isClickToHide() && popupVisible) {
                return;
            }
            _this.setPopupVisible(!popupVisible, 0);
        };
        _this.onFocus = function (e) {
            var focusDelay = _this.getMergedProps().focusDelay;
            var onFocus = function () {
                _this.triggerPropsEvent('onFocus', e);
            };
            _this.clearDelayTimer();
            if (!_this.mousedownToHide) {
                if (_this.state.popupVisible) {
                    onFocus && onFocus();
                }
                else {
                    _this.setPopupVisible(true, focusDelay || 0, onFocus);
                }
            }
            _this.mousedownToHide = false;
        };
        _this.onBlur = function (e) {
            _this.setPopupVisible(false, 200, function () { return _this.triggerPropsEvent('onBlur', e); });
        };
        _this.onResize = function () {
            if (_this.getMergedProps().autoFixPosition && _this.state.popupVisible) {
                _this.updatePopupPosition();
            }
        };
        _this.onPopupMouseDown = function () {
            _this.hasPopupMouseDown = true;
            clearTimeout(_this.mouseDownTimeout);
            _this.mouseDownTimeout = setTimeout(function () {
                _this.hasPopupMouseDown = false;
            }, 0);
        };
        // 当 children 中的元素 disabled 时，不能正确触发 hover 等事件，所以当监测到对应
        // 组件有 disabled 时，给元素加一层 span，处理事件，模拟样式
        _this.getChild = function () {
            var _a;
            var children = _this.props.children;
            var element = children;
            var elementType = (element && typeof element !== 'string' && element.type);
            var child = children;
            if (['string', 'number'].indexOf(typeof children) > -1 || react.Children.count(children) > 1) {
                child = react.createElement("span", null, children);
            }
            else if (element &&
                elementType &&
                (elementType.__BYTE_BUTTON === true ||
                    elementType.__BYTE_CHECKBOX === true ||
                    elementType.__BYTE_SWITCH === true ||
                    elementType.__BYTE_RADIO === true ||
                    elementType === 'button') &&
                element.props.disabled) {
                // 从样式中提取出会影响布局的到上层 span 样式中。
                var _b = splitChildrenStyle(element.props.style, [
                    'position',
                    'left',
                    'right',
                    'top',
                    'bottom',
                    'float',
                    'display',
                    'zIndex',
                ]), picked = _b.picked, omitted = _b.omitted;
                child = (react.createElement("span", { className: (_a = element.props) === null || _a === void 0 ? void 0 : _a.className, style: Trigger_assign(Trigger_assign({ display: 'inline-block' }, picked), { cursor: 'not-allowed' }) }, react.cloneElement(element, {
                    style: Trigger_assign(Trigger_assign({}, omitted), { pointerEvents: 'none' }),
                    className: undefined,
                })));
            }
            // 防止为空报错
            return child || react.createElement("span", null);
        };
        // 创建的dom节点插入getPopupContainer。
        _this.appendToContainer = function (node) {
            (0,raf/* caf */.N)(_this.rafId);
            if (_this.isDidMount) {
                var getGlobalPopupContainer = _this.context.getPopupContainer;
                var getPopupContainer = _this.getMergedProps().getPopupContainer;
                var gpc = getPopupContainer || getGlobalPopupContainer;
                var rootElement = _this.getRootElement();
                var parent_1 = gpc(rootElement);
                if (parent_1) {
                    parent_1.appendChild(node);
                    return;
                }
            }
            _this.rafId = (0,raf/* raf */.W)(function () {
                _this.appendToContainer(node);
            });
        };
        _this.getContainer = function () {
            var popupContainer = document.createElement('div');
            popupContainer.style.width = '100%';
            popupContainer.style.position = 'absolute';
            popupContainer.style.top = '0';
            popupContainer.style.left = '0';
            _this.popupContainer = popupContainer;
            _this.appendToContainer(popupContainer);
            return popupContainer;
        };
        // 1. 触发直接附加到 Trigger 上的事件，大多是Trigger直接嵌套Trigger的情况
        // 2. 触发children上直接被附加的事件
        _this.triggerPropsEvent = function (eventName, e) {
            var child = _this.getChild();
            var childHandler = child && child.props && child.props[eventName];
            var props = _this.getMergedProps();
            if ((0,is/* isFunction */.mf)(childHandler)) {
                childHandler(e);
            }
            if ((0,is/* isFunction */.mf)(props[eventName])) {
                props[eventName](e);
            }
        };
        // 触发 children/ trigger 组件上被附加的事件
        _this.triggerOriginEvent = function (eventName) {
            var child = _this.getChild();
            var childHandler = child && child.props && child.props[eventName];
            var propsHandler = _this.getMergedProps()[eventName];
            if ((0,is/* isFunction */.mf)(propsHandler) && (0,is/* isFunction */.mf)(childHandler)) {
                return function (e) {
                    childHandler(e);
                    propsHandler(e);
                };
            }
            return childHandler || propsHandler;
        };
        var mergedProps = _this.getMergedProps(props);
        var popupVisible = 'popupVisible' in mergedProps ? mergedProps.popupVisible : mergedProps.defaultPopupVisible;
        _this.popupOpen = !!popupVisible;
        _this.state = {
            popupVisible: !!popupVisible,
            popupStyle: {},
        };
        return _this;
    }
    Trigger.getDerivedStateFromProps = function (nextProps, state) {
        if ('popupVisible' in nextProps && nextProps.popupVisible !== state.popupVisible) {
            return {
                popupVisible: nextProps.popupVisible,
            };
        }
        return null;
    };
    Trigger.prototype.componentDidMount = function () {
        this.componentDidUpdate(this.getMergedProps());
        this.isDidMount = true;
        this.unmount = false;
        this.childrenDom = this.getRootElement();
        if (this.state.popupVisible) {
            this.childrenDomSize = getDOMPos(this.childrenDom);
        }
    };
    Trigger.prototype.componentDidUpdate = function (_prevProps) {
        var prevProps = this.getMergedProps(_prevProps);
        var currentProps = this.getMergedProps();
        if (!prevProps.popupVisible && currentProps.popupVisible) {
            this.update();
        }
        var popupVisible = this.state.popupVisible;
        this.popupOpen = popupVisible;
        var getDocument = currentProps.getDocument;
        if (!popupVisible) {
            this.offClickOutside();
            this.offContainerResize();
            this.offWindowResize();
            this.offScrollListeners();
            return;
        }
        var rect = getDOMPos(this.childrenDom);
        // children节点的尺寸改变，主要是处理children 存在scale等动画属性，或者移动位置的时候，popup 的位置有问题
        if (JSON.stringify(rect) !== JSON.stringify(this.childrenDomSize)) {
            this.updatePopupPosition();
            this.childrenDomSize = rect;
        }
        // popupVisible为true
        this.onContainerResize();
        if (currentProps.updateOnScroll || currentProps.containerScrollToClose) {
            this.onContainersScroll(currentProps);
        }
        if (!this.handleWindowResize) {
            (0,dom.on)(window, 'resize', this.handleUpdatePosition);
            this.handleWindowResize = true;
        }
        if (!this.handleClickOutside) {
            var root = (0,is/* isFunction */.mf)(getDocument) && getDocument();
            if (root) {
                // clickOutside 必须监听mousedown。
                // 1. 如果事件目标元素在click后被移除，document.onclick被触发时已经没有该元素，会错误触发clickOutside逻辑，隐藏popup。
                // 2. 点击label标签，会触发对应input元素的点击事件，导致触发clickOutside，隐藏popup。
                (0,dom.on)(root, 'mousedown', this.onClickOutside, {
                    capture: (0,is/* isObject */.Kn)(currentProps.clickOutsideToClose)
                        ? currentProps.clickOutsideToClose.capture
                        : false,
                });
                this.handleClickOutside = true;
            }
        }
    };
    Trigger.prototype.componentWillUnmount = function () {
        this.unmount = true;
        this.offClickOutside();
        this.clearTimer();
        this.offWindowResize();
        this.offScrollListeners();
        this.offContainerResize();
        (0,raf/* caf */.N)(this.rafId);
    };
    Trigger.prototype.clearDelayTimer = function () {
        if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
        }
    };
    Trigger.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var _d;
        var _e = this.getMergedProps(), children = _e.children, style = _e.style, className = _e.className, arrowProps = _e.arrowProps, disabled = _e.disabled, popup = _e.popup, classNames = _e.classNames, duration = _e.duration, unmountOnExit = _e.unmountOnExit, alignPoint = _e.alignPoint, autoAlignPopupWidth = _e.autoAlignPopupWidth, position = _e.position, childrenPrefix = _e.childrenPrefix, showArrow = _e.showArrow, dropdownPopupStyle = _e.popupStyle, __onExit = _e.__onExit, __onExited = _e.__onExited;
        var isExistChildren = children || children === 0;
        var _f = this.context, getPrefixCls = _f.getPrefixCls, zIndex = _f.zIndex, rtl = _f.rtl;
        var _g = this.state, popupVisible = _g.popupVisible, popupStyle = _g.popupStyle;
        if (!popup) {
            return null;
        }
        var mergeProps = {};
        var popupEventProps = {
            onMouseDown: this.onPopupMouseDown,
        };
        if (this.isHoverTrigger() && !disabled) {
            mergeProps.onMouseEnter = this.onMouseEnter;
            mergeProps.onMouseLeave = this.onMouseLeave;
            // https://github.com/arco-design/arco-design/issues/1804
            // TODO: remove login in next major version
            if (this.isClickToHide()) {
                mergeProps.onClick = this.clickToHidePopup;
            }
            if (alignPoint) {
                mergeProps.onMouseMove = this.onMouseMove;
            }
            if (!this.isPopupHoverHide()) {
                popupEventProps.onMouseEnter = this.onPopupMouseEnter;
                popupEventProps.onMouseLeave = this.onPopupMouseLeave;
            }
        }
        else {
            mergeProps.onMouseEnter = this.triggerOriginEvent('onMouseEnter');
            mergeProps.onMouseLeave = this.triggerOriginEvent('onMouseLeave');
        }
        if (this.isContextMenuTrigger() && !disabled) {
            mergeProps.onContextMenu = this.onContextMenu;
            mergeProps.onClick = this.clickToHidePopup;
        }
        else {
            mergeProps.onContextMenu = this.triggerOriginEvent('onContextMenu');
        }
        if (this.isClickTrigger() && !disabled) {
            mergeProps.onClick = this.onClick;
        }
        else {
            mergeProps.onClick = mergeProps.onClick || this.triggerOriginEvent('onClick');
        }
        if (this.isFocusTrigger() && !disabled) {
            mergeProps.onFocus = this.onFocus;
            if (this.isBlurToHide()) {
                mergeProps.onBlur = this.onBlur;
            }
        }
        else {
            mergeProps.onFocus = this.triggerOriginEvent('onFocus');
            mergeProps.onBlur = this.triggerOriginEvent('onBlur');
        }
        if (!disabled) {
            mergeProps.onKeyDown = this.onKeyDown;
        }
        else {
            mergeProps.onKeyDown = this.triggerOriginEvent('onKeyDown');
        }
        var child = this.getChild();
        var popupChildren = react.Children.only(popup());
        if (child.props.className) {
            mergeProps.className = child.props.className;
        }
        if (childrenPrefix && popupVisible) {
            mergeProps.className = mergeProps.className
                ? mergeProps.className + " " + childrenPrefix + "-open"
                : childrenPrefix + "-open";
        }
        // 只有在focus触发时，设置tabIndex，点击tab键，能触发focus事件，展示弹出框
        if (this.isFocusTrigger()) {
            mergeProps.tabIndex = disabled ? -1 : 0;
        }
        var prefixCls = getPrefixCls('trigger');
        var popupClassName = (0,_util_classNames/* default */.Z)(prefixCls, childrenPrefix, prefixCls + "-position-" + position, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className);
        var childrenComponent = isExistChildren && (react.createElement(resizeObserver/* default */.Z, { onResize: this.onResize }, react.cloneElement(child, Trigger_assign({}, mergeProps))));
        var portalContent = (react.createElement(CSSTransition/* default */.Z, { in: !!popupVisible, timeout: duration, classNames: classNames, unmountOnExit: unmountOnExit, appear: true, mountOnEnter: true, onEnter: function (e) {
                e.style.display = 'initial';
                e.style.pointerEvents = 'none';
                if (classNames === 'slideDynamicOrigin') {
                    // 下拉菜单
                    e.style.transform = _this.getTransformTranslate();
                }
            }, onEntering: function (e) {
                if (classNames === 'slideDynamicOrigin') {
                    // 下拉菜单
                    e.style.transform = '';
                }
            }, onEntered: function (e) {
                e.style.pointerEvents = 'auto';
                _this.forceUpdate();
            }, onExit: function (e) {
                // 避免消失动画时对元素的快速点击触发意外的操作
                e.style.pointerEvents = 'none';
                __onExit === null || __onExit === void 0 ? void 0 : __onExit(e);
            }, onExited: function (e) {
                e.style.display = 'none';
                // 这里立即设置为null是为了在setState popupStyle引起重新渲染时，能触发 Portal的卸载事件。移除父节点。
                // 否则只有在下个循环中 triggerRef 才会变为null，需要重新forceUpdate，才能触发Portal的unmount。
                if (unmountOnExit) {
                    _this.triggerRef = null;
                }
                _this.setState({ popupStyle: {} });
                __onExited === null || __onExited === void 0 ? void 0 : __onExited(e);
            } },
            react.createElement(resizeObserver/* default */.Z, { onResize: function () {
                    var target = _this.triggerRef;
                    if (target) {
                        // Avoid the flickering problem caused by the size change and positioning not being recalculated in time.
                        // TODO: Consider changing the popup style directly  in the next major version
                        var popupStyle_1 = _this.getPopupStyle();
                        var style_1 = _this.props.style || {};
                        target.style.top = String(style_1.top || popupStyle_1.top + "px");
                        target.style.left = String(style_1.left || popupStyle_1.left + "px");
                    }
                    _this.onResize();
                } },
                react.createElement("span", Trigger_assign({ ref: function (node) { return (_this.triggerRef = node); }, "trigger-placement": this.realPosition, style: Trigger_assign(Trigger_assign(Trigger_assign({ width: autoAlignPopupWidth && (style === null || style === void 0 ? void 0 : style.width) === undefined
                            ? (_d = this.childrenDomSize) === null || _d === void 0 ? void 0 : _d.width
                            : '' }, popupStyle), { position: 'absolute', zIndex: zIndex || '' }), style) }, popupEventProps, { className: popupClassName }, (0,pick/* pickDataAttributes */.m)(this.props)),
                    react.createElement(popupChildren.type, Trigger_assign({ ref: popupChildren.ref }, popupChildren.props, { style: Trigger_assign(Trigger_assign({}, popupChildren.props.style), dropdownPopupStyle) })),
                    (showArrow || arrowProps) && (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-arrow-container", (_b = {},
                            _b[childrenPrefix + "-arrow-container"] = childrenPrefix,
                            _b)) },
                        react.createElement("div", Trigger_assign({}, arrowProps, { className: (0,_util_classNames/* default */.Z)(prefixCls + "-arrow", (_c = {},
                                _c[childrenPrefix + "-arrow"] = childrenPrefix,
                                _c), arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.className), style: Trigger_assign(Trigger_assign({}, this.arrowStyle), arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.style) }))))))));
        // 如果 triggerRef 不存在，说明弹出层内容被销毁，可以隐藏portal。
        var portal = popupVisible || this.triggerRef ? (react.createElement(Trigger_portal, { getContainer: this.getContainer }, portalContent)) : null;
        return isExistChildren ? (react.createElement(react.Fragment, null,
            childrenComponent,
            portal)) : (portal);
    };
    Trigger.displayName = 'Trigger';
    Trigger.contextType = ConfigProvider/* ConfigContext */.E_;
    return Trigger;
}(react.PureComponent));
/* harmony default export */ var es_Trigger = (Trigger);


/***/ }),

/***/ 39612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Upload; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/interface.js
var STATUS = {
    init: 'init',
    uploading: 'uploading',
    success: 'done',
    fail: 'error',
};

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Progress/index.js + 3 modules
var Progress = __webpack_require__(31604);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCheck/index.js
var IconCheck = __webpack_require__(34553);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconUpload/index.js
var IconUpload = __webpack_require__(14539);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPlayArrowFill/index.js
var IconPlayArrowFill = __webpack_require__(62606);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPause/index.js
var IconPause = __webpack_require__(24423);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/list/uploadProgress.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};











var UploadProgress = function (props) {
    var keyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var file = props.file, prefixCls = props.prefixCls, progressProps = props.progressProps, progressRender = props.progressRender;
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var status = file.status, _a = file.percent, percent = _a === void 0 ? 0 : _a;
    var cls = prefixCls + "-list";
    var widthStyle = progressProps && progressProps.width ? { width: progressProps.width } : {};
    var dom = (react.createElement(react.Fragment, null,
        status === STATUS.fail && props.reuploadIcon !== null && (react.createElement("span", __assign({ className: prefixCls + "-list-reupload-icon", onClick: function () {
                props.onReupload && props.onReupload(file);
            }, tabIndex: 0, role: "button", "aria-label": locale.Upload.reupload }, keyboardEvents({
            onPressEnter: function () {
                props.onReupload && props.onReupload(file);
            },
        })), props.reuploadIcon ||
            (props.listType === 'picture-card' ? react.createElement(IconUpload/* default */.Z, null) : locale.Upload.reupload))),
        status === STATUS.success && props.successIcon !== null && (react.createElement("span", { className: prefixCls + "-list-success-icon" }, props.successIcon || react.createElement(IconCheck/* default */.Z, null))),
        status !== STATUS.success && (react.createElement("div", { className: cls + "-status", style: widthStyle },
            react.createElement(Progress/* default */.Z, __assign({ showText: false, className: cls + "-progress", type: "circle", status: status === STATUS.fail ? 'error' : status === STATUS.success ? 'success' : 'normal', percent: percent, size: "mini" }, progressProps)),
            status === STATUS.init && props.startIcon !== null && (react.createElement("span", __assign({ tabIndex: 0, role: "button", "aria-label": locale.Upload.start, className: prefixCls + "-list-start-icon", onClick: function () {
                    props.onUpload && props.onUpload(file);
                } }, keyboardEvents({
                onPressEnter: function () {
                    props.onUpload && props.onUpload(file);
                },
            })), props.startIcon || (react.createElement(Tooltip/* default */.Z, { content: locale.Upload.start },
                react.createElement(IconPlayArrowFill/* default */.Z, null))))),
            status === STATUS.uploading && props.cancelIcon !== null && (react.createElement("span", __assign({ className: props.prefixCls + "-list-cancel-icon", onClick: function () {
                    props.onAbort && props.onAbort(file);
                }, tabIndex: 0, "aria-label": locale.Upload.cancel }, keyboardEvents({
                onPressEnter: function () {
                    props.onAbort && props.onAbort(file);
                },
            })), props.cancelIcon || (react.createElement(Tooltip/* default */.Z, { content: locale.Upload.cancel },
                react.createElement(IconPause/* default */.Z, null)))))))));
    return (0,is/* isFunction */.mf)(progressRender) ? progressRender(file, dom) : dom;
};
/* harmony default export */ var uploadProgress = (UploadProgress);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconImageClose/index.js
var IconImageClose = __webpack_require__(81485);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEye/index.js
var IconEye = __webpack_require__(23835);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDelete/index.js
var IconDelete = __webpack_require__(61873);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/list/pictureItem.js
var pictureItem_assign = (undefined && undefined.__assign) || function () {
    pictureItem_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return pictureItem_assign.apply(this, arguments);
};









var PictureItem = function (props) {
    var disabled = props.disabled, prefixCls = props.prefixCls, file = props.file, showUploadList = props.showUploadList, locale = props.locale;
    var keyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var cls = prefixCls + "-list-item-picture";
    var status = file.status, originFile = file.originFile;
    var url = file.url !== undefined
        ? file.url
        : originFile && (0,is/* isFunction */.mf)(URL.createObjectURL) && URL.createObjectURL(originFile);
    var actionIcons = (0,is/* isObject */.Kn)(showUploadList) ? showUploadList : {};
    return (react.createElement("div", { className: cls }, status === STATUS.uploading ? (react.createElement(uploadProgress, pictureItem_assign({ onReupload: props.onReupload, onUpload: props.onUpload, onAbort: props.onAbort, listType: "picture-card", file: file, prefixCls: prefixCls, progressProps: props.progressProps }, actionIcons))) : (react.createElement(react.Fragment, null,
        (0,is/* isFunction */.mf)(actionIcons.imageRender) ? (actionIcons.imageRender(file)) : (react.createElement("img", { src: url, alt: file.name })),
        react.createElement("div", { className: cls + "-mask", role: "radiogroup" },
            file.status === STATUS.fail && (react.createElement("div", { className: cls + "-error-tip" }, actionIcons.errorIcon !== null && (react.createElement("span", { className: prefixCls + "-list-error-icon" }, actionIcons.errorIcon || react.createElement(IconImageClose/* default */.Z, null))))),
            react.createElement("div", { className: cls + "-operation" },
                file.status !== STATUS.fail && actionIcons.previewIcon !== null && (react.createElement("span", pictureItem_assign({ className: prefixCls + "-list-preview-icon", tabIndex: 0, role: "button", "aria-label": locale.Upload.preview }, keyboardEvents({
                    onPressEnter: function () {
                        props.onPreview && props.onPreview(file);
                    },
                }), { onClick: function () {
                        props.onPreview && props.onPreview(file);
                    } }), actionIcons.previewIcon || react.createElement(IconEye/* default */.Z, null))),
                file.status === STATUS.fail && actionIcons.reuploadIcon !== null && (react.createElement("span", pictureItem_assign({ className: props.prefixCls + "-list-reupload-icon", onClick: function () {
                        props.onReupload && props.onReupload(file);
                    }, tabIndex: 0, role: "button", "aria-label": locale.Upload.reupload }, keyboardEvents({
                    onPressEnter: function () {
                        props.onReupload && props.onReupload(file);
                    },
                })), actionIcons.reuploadIcon || react.createElement(IconUpload/* default */.Z, null))),
                !disabled && actionIcons.removeIcon !== null && (react.createElement("span", pictureItem_assign({ className: prefixCls + "-list-remove-icon", onClick: function () {
                        props.onRemove && props.onRemove(file);
                    }, role: "button", "aria-label": locale.Upload.delete, tabIndex: 0 }, keyboardEvents({
                    onPressEnter: function () {
                        props.onRemove && props.onRemove(file);
                    },
                })), actionIcons.removeIcon || react.createElement(IconDelete/* default */.Z, null)))))))));
};
/* harmony default export */ var pictureItem = (PictureItem);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFile/index.js
var IconFile = __webpack_require__(88590);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFilePdf/index.js
var IconFilePdf = __webpack_require__(208);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFileImage/index.js
var IconFileImage = __webpack_require__(81128);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFileVideo/index.js
var IconFileVideo = __webpack_require__(89165);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconFileAudio/index.js
var IconFileAudio = __webpack_require__(69702);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconExclamationCircleFill/index.js
var IconExclamationCircleFill = __webpack_require__(67012);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/list/textItem.js
var textItem_assign = (undefined && undefined.__assign) || function () {
    textItem_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return textItem_assign.apply(this, arguments);
};














var getIconType = function (file) {
    var type = '';
    if (file.originFile && file.originFile.type) {
        // 上传文件
        type = file.originFile.type;
    }
    else {
        var name_1 = file.name || '';
        var fileExtension = name_1.split('.').pop() || '';
        type = fileExtension;
        if (['png', 'jpg', 'jpeg', 'bmp', 'gif'].indexOf(fileExtension) > -1) {
            type = 'image';
        }
        else if (['mp4', 'm2v', 'mkv'].indexOf(fileExtension) > -1) {
            type = 'video';
        }
        else if (['mp3', 'wav', 'wmv'].indexOf(fileExtension) > -1) {
            type = 'audio';
        }
    }
    if (type.indexOf('image') > -1) {
        return IconFileImage/* default */.Z;
    }
    if (type.indexOf('pdf') > -1) {
        return IconFilePdf/* default */.Z;
    }
    if (type.indexOf('audio') > -1) {
        return IconFileAudio/* default */.Z;
    }
    if (type.indexOf('video') > -1) {
        return IconFileVideo/* default */.Z;
    }
    return IconFile/* default */.Z;
};
var TextItem = function (props) {
    var prefixCls = props.prefixCls, disabled = props.disabled, file = props.file, locale = props.locale;
    var cls = prefixCls + "-list-item-text";
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var Icon = getIconType(file);
    var showUploadList = (0,is/* isObject */.Kn)(props.showUploadList)
        ? props.showUploadList
        : {};
    // custom icons
    var actionIcons = (0,is/* isObject */.Kn)(showUploadList) ? showUploadList : {};
    var fileName = file.name || (file.originFile && file.originFile.name);
    var url = file.url !== undefined
        ? file.url
        : file.originFile && (0,is/* isFunction */.mf)(URL.createObjectURL) && URL.createObjectURL(file.originFile);
    var triggerProps = {};
    // 重新上传后，如果成功，但是鼠标仍然hover在内容区，错误提示不会消失。所以需要设置 popupVisible 为false，来隐藏tooltip
    if (file.status !== STATUS.fail) {
        triggerProps = {
            popupVisible: false,
        };
    }
    return (react.createElement("div", { className: prefixCls + "-list-item " + prefixCls + "-list-item-" + file.status },
        react.createElement("div", { className: cls },
            props.listType === 'picture-list' && (react.createElement("div", { className: cls + "-thumbnail" }, (0,is/* isFunction */.mf)(showUploadList.imageRender) ? (showUploadList.imageRender(file)) : (react.createElement("img", { src: url })))),
            react.createElement("div", { className: cls + "-content" },
                react.createElement("div", { className: cls + "-name" },
                    props.listType === 'text' && actionIcons.fileIcon !== null && (react.createElement("span", { className: prefixCls + "-list-file-icon" }, actionIcons.fileIcon || react.createElement(Icon, null))),
                    (0,is/* isFunction */.mf)(showUploadList.fileName) ? (react.createElement("span", { className: cls + "-name-text" }, showUploadList.fileName(file))) : file.url ? (react.createElement("a", { href: file.url, target: "_blank", rel: "noreferrer", className: cls + "-name-link" }, fileName)) : (react.createElement("span", { className: cls + "-name-text" }, fileName)),
                    file.status === STATUS.fail && actionIcons.errorIcon !== null && (react.createElement(Tooltip/* default */.Z, textItem_assign({ content: file.response || locale.Upload.error }, triggerProps, { disabled: file.status !== STATUS.fail }),
                        react.createElement("span", { className: props.prefixCls + "-list-error-icon" }, actionIcons.errorIcon ||
                            (props.listType === 'picture-card' ? (react.createElement(IconFileImage/* default */.Z, null)) : (react.createElement(IconExclamationCircleFill/* default */.Z, null))))))),
                react.createElement(uploadProgress, textItem_assign({ file: file, prefixCls: prefixCls, progressProps: props.progressProps, onReupload: props.onReupload, onUpload: props.onUpload, onAbort: props.onAbort }, actionIcons)))),
        react.createElement("div", { className: prefixCls + "-list-item-operation" }, !disabled && actionIcons.removeIcon !== null && (react.createElement(icon_hover/* default */.Z, textItem_assign({ className: prefixCls + "-list-remove-icon-hover", onClick: function () {
                props.onRemove && props.onRemove(file);
            }, tabIndex: 0, "aria-label": locale.Upload.delete }, getKeyboardEvents({
            onPressEnter: function () {
                props.onRemove && props.onRemove(file);
            },
        })),
            react.createElement("span", { className: prefixCls + "-list-remove-icon" }, actionIcons.removeIcon || react.createElement(IconDelete/* default */.Z, null)))))));
};
/* harmony default export */ var textItem = (TextItem);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Image/image-preview-group.js
var image_preview_group = __webpack_require__(65808);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/list/index.js
var list_assign = (undefined && undefined.__assign) || function () {
    list_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return list_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









var FileList = function (props) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), locale = _b.locale, rtl = _b.rtl;
    var listType = props.listType, fileList = props.fileList, renderUploadList = props.renderUploadList, renderUploadItem = props.renderUploadItem, prefixCls = props.prefixCls, rest = __rest(props, ["listType", "fileList", "renderUploadList", "renderUploadItem", "prefixCls"]);
    // hide image preview when previewCurrent = -1
    var _c = __read((0,react.useState)(-1), 2), previewCurrent = _c[0], setPreviewCurrent = _c[1];
    var srcList = (0,react.useMemo)(function () {
        return fileList
            .map(function (file) {
            var url = file.url;
            if (file.url === undefined && [STATUS.init, STATUS.success].indexOf(file.status) > -1) {
                url =
                    file.originFile &&
                        (0,is/* isFunction */.mf)(URL.createObjectURL) &&
                        URL.createObjectURL(file.originFile);
            }
            return url;
        })
            .filter(Boolean);
    }, [fileList]);
    if ((0,is/* isFunction */.mf)(renderUploadList)) {
        return react.createElement("div", { className: prefixCls + "-list" }, renderUploadList(fileList, rest));
    }
    var updatePreviewCurrent = function (current) {
        if (props.imagePreview) {
            setPreviewCurrent(current);
        }
    };
    return (react.createElement(react.Fragment, null,
        react.createElement(TransitionGroup/* default */.Z, { className: (0,classNames/* default */.Z)(prefixCls + "-list", prefixCls + "-list-type-" + listType, (_a = {},
                _a[prefixCls + "-list-rtl"] = rtl,
                _a)) }, fileList.map(function (file, index) {
            var originNode = listType === 'picture-card' ? (react.createElement("div", { className: prefixCls + "-list-item " + prefixCls + "-list-item-" + file.status },
                react.createElement(pictureItem, list_assign({}, props, { onPreview: function (file) {
                        var _a;
                        updatePreviewCurrent(index);
                        (_a = props.onPreview) === null || _a === void 0 ? void 0 : _a.call(props, file);
                    }, file: file, locale: locale })))) : (react.createElement(textItem, list_assign({}, props, { file: file, locale: locale })));
            if ((0,is/* isFunction */.mf)(renderUploadItem)) {
                originNode = renderUploadItem(originNode, file, fileList);
            }
            return listType === 'picture-card' ? (react.createElement(CSSTransition/* default */.Z, { key: file.uid, timeout: { enter: 200, exit: 400 }, classNames: prefixCls + "-slide-inline", onEntered: function (e) {
                    e.style.width = '';
                }, onExit: function (e) {
                    e.style.width = e.scrollWidth + "px";
                }, onExiting: function (e) {
                    e.style.width = 0;
                }, onExited: function (e) {
                    e.style.width = 0;
                } }, originNode)) : (react.createElement(CSSTransition/* default */.Z, { key: file.uid, timeout: { enter: 200, exit: 400 }, classNames: prefixCls + "-slide-up", onExit: function (e) {
                    e.style.height = e.scrollHeight + "px";
                }, onExiting: function (e) {
                    e.style.height = 0;
                }, onExited: function (e) {
                    e.style.height = 0;
                } }, originNode));
        })),
        listType === 'picture-card' && props.imagePreview && (react.createElement(image_preview_group/* default */.Z, { srcList: srcList, visible: previewCurrent !== -1, current: previewCurrent, onChange: updatePreviewCurrent, onVisibleChange: function (visible) {
                updatePreviewCurrent(visible ? previewCurrent : -1);
            } }))));
};
FileList.displayName = 'FileList';
/* harmony default export */ var list = (FileList);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/constant.js
var constant = __webpack_require__(91702);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/request.js

function getBody(xhr) {
    var text = xhr.responseText || xhr.response;
    if (!text) {
        return text;
    }
    try {
        return JSON.parse(text);
    }
    catch (e) {
        return text;
    }
}
var uploadRequest = function (options) {
    var _a = options.onProgress, onProgress = _a === void 0 ? constant/* NOOP */.dG : _a, _b = options.onError, onError = _b === void 0 ? constant/* NOOP */.dG : _b, _c = options.onSuccess, onSuccess = _c === void 0 ? constant/* NOOP */.dG : _c, action = options.action, method = options.method, _d = options.headers, headers = _d === void 0 ? {} : _d, originName = options.name, file = options.file, _e = options.data, originData = _e === void 0 ? {} : _e, _f = options.withCredentials, withCredentials = _f === void 0 ? false : _f;
    function getValue(value) {
        if (typeof value === 'function') {
            return value(file);
        }
        return value;
    }
    var name = getValue(originName);
    var data = getValue(originData);
    var xhr = new XMLHttpRequest();
    if (onProgress && xhr.upload) {
        xhr.upload.onprogress = function (event) {
            var percent;
            if (event.total > 0) {
                percent = (event.loaded / event.total) * 100;
            }
            onProgress(parseInt(percent, 10), event);
        };
    }
    xhr.onerror = function error(e) {
        onError(e);
    };
    xhr.onload = function onload() {
        if (xhr.status < 200 || xhr.status >= 300) {
            return onError(getBody(xhr));
        }
        onSuccess(getBody(xhr));
    };
    var formData = new FormData();
    if (data) {
        Object.keys(data).map(function (key) { return formData.append(key, data[key]); });
    }
    formData.append(name || 'file', file);
    xhr.open(method, action, true);
    if (withCredentials && 'withCredentials' in xhr) {
        xhr.withCredentials = true;
    }
    for (var h in headers) {
        if (headers.hasOwnProperty(h) && headers[h] !== null) {
            xhr.setRequestHeader(h, headers[h]);
        }
    }
    xhr.send(formData);
    return {
        abort: function () {
            xhr.abort();
        },
    };
};
/* harmony default export */ var Upload_request = (uploadRequest);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconPlus/index.js
var IconPlus = __webpack_require__(84566);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/util.js

var isAcceptFile = function (file, propsAccept) {
    var accept = (0,is/* isObject */.Kn)(propsAccept) ? propsAccept === null || propsAccept === void 0 ? void 0 : propsAccept.type : propsAccept;
    // 显示设置 strict=false，才是非严格模式，不走过滤逻辑
    var strict = !((0,is/* isObject */.Kn)(propsAccept) && propsAccept.strict === false);
    if (strict && accept && file) {
        var accepts = (0,is/* isArray */.kJ)(accept)
            ? accept
            : accept
                .split(',')
                .map(function (x) { return x.trim(); })
                .filter(function (x) { return x; });
        var fileExtension_1 = (file.name.indexOf('.') > -1 ? "." + file.name.split('.').pop() : '').toLowerCase();
        return accepts.some(function (type) {
            var typeText = type && type.toLowerCase();
            var fileType = (file.type || '').toLowerCase();
            var baseFileType = fileType.split('/')[0]; // audio/mpeg => audio;
            // `${baseFileType}/${fileExtension}` === typeText
            // filetype is audio/mpeg, but accept is audio/mp3, should return true
            if (typeText === fileType ||
                "" + baseFileType + fileExtension_1.replace('.', '/') === typeText) {
                // 类似excel文件这种
                // 比如application/vnd.ms-excel和application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                // 本身就带有.字符的，不能走下面的.jpg等文件扩展名判断处理
                // 所以优先对比input的accept类型和文件对象的type值
                return true;
            }
            // */*,*  之类的所有类型
            if (/^\*(\/\*)?$/.test(typeText)) {
                return true;
            }
            if (/\/\*/.test(typeText)) {
                // image/* 这种通配的形式处理
                return fileType.replace(/\/.*$/, '') === typeText.replace(/\/.*$/, '');
            }
            if (/\..*/.test(typeText)) {
                // .jpg 等后缀名
                var suffixList = [typeText];
                // accept=".jpg", jpeg后缀类型同样可以上传，反之亦然
                if (typeText === '.jpg' || typeText === '.jpeg') {
                    suffixList = ['.jpg', '.jpeg'];
                }
                return suffixList.indexOf(fileExtension_1) > -1;
            }
            return false;
        });
    }
    return !!file;
};
var getFiles = function (fileList, accept) {
    if (!fileList) {
        return;
    }
    var files = [].slice.call(fileList);
    if (accept) {
        files = files.filter(function (file) {
            return isAcceptFile(file, accept);
        });
    }
    return files;
};
var loopDirectory = function (items, accept, callback) {
    var files = [];
    var restFileCount = 0; // 剩余上传文件的数量
    var onFinish = function () {
        !restFileCount && callback(files);
    };
    var _loopDirectory = function (item) {
        restFileCount += 1;
        if (item.isFile) {
            item.file(function (file) {
                restFileCount -= 1;
                if (isAcceptFile(file, accept)) {
                    Object.defineProperty(file, 'webkitRelativePath', {
                        value: item.fullPath.replace(/^\//, ''),
                    });
                    files.push(file);
                }
                onFinish();
            });
            return;
        }
        if (item.isDirectory) {
            // item 是个文件夹
            var reader_1 = item.createReader();
            var flag_1 = false;
            var readEntries_1 = function () {
                reader_1.readEntries(function (entries) {
                    if (!flag_1) {
                        restFileCount -= 1;
                        flag_1 = true;
                    }
                    if (entries.length === 0) {
                        onFinish();
                    }
                    else {
                        readEntries_1(); // the maximum files read using readEntries is 100
                        entries.forEach(_loopDirectory);
                    }
                });
            };
            readEntries_1();
            return;
        }
        restFileCount -= 1;
        onFinish();
    };
    var list = [].slice.call(items);
    list.forEach(function (item) {
        if (item.webkitGetAsEntry) {
            _loopDirectory(item.webkitGetAsEntry());
        }
    });
};

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/trigger-node.js
var trigger_node_assign = (undefined && undefined.__assign) || function () {
    trigger_node_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return trigger_node_assign.apply(this, arguments);
};
var trigger_node_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var TriggerNode = function (props) {
    var _a, _b;
    var getKeyboardEvents = (0,useKeyboardEvent/* default */.Z)();
    var locale = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).locale;
    var _c = trigger_node_read((0,react.useState)(false), 2), isDragging = _c[0], setIsDragging = _c[1];
    var _d = trigger_node_read((0,react.useState)(0), 2), dragEnterCount = _d[0], setDragEnterCount = _d[1]; // the number of times ondragenter was triggered
    var tip = props.tip, children = props.children, disabled = props.disabled, drag = props.drag, listType = props.listType, prefixCls = props.prefixCls, accept = props.accept, multiple = props.multiple;
    var nodeProps = {
        disabled: disabled,
    };
    (0,react.useEffect)(function () {
        setDragEnterCount(0);
    }, [isDragging]);
    return children === null ? null : (react.createElement("div", trigger_node_assign({ className: prefixCls + "-trigger", onClick: disabled ? undefined : props.onClick }, getKeyboardEvents({
        onPressEnter: function () {
            var _a;
            !disabled && ((_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props));
        },
    }), { onDragEnter: function () {
            setDragEnterCount(dragEnterCount + 1);
        }, onDragLeave: function (e) {
            var _a;
            e.preventDefault();
            /**  When dragging into a child element, it will trigger the dragleave and dragenter of the parent node.
             * Record the number of triggers of dragenter, and subtract 1 each time dragleave.
             * When dragEnterCount is equal to 0,  it means that the mouse has left the current node, then the drag state is cancelled.
             * https://github.com/arco-design/arco-design/issues/210
             */
            if (dragEnterCount === 0) {
                setIsDragging(false);
                !disabled && ((_a = props.onDragLeave) === null || _a === void 0 ? void 0 : _a.call(props, e));
            }
            else {
                setDragEnterCount(dragEnterCount - 1);
            }
        }, onDrop: function (e) {
            e.preventDefault();
            if (!disabled && props.drag !== false) {
                setIsDragging(false);
                if (props.directory) {
                    loopDirectory(e.dataTransfer.items, accept, function (files) {
                        props.onDragFiles && props.onDragFiles(files);
                    });
                }
                else {
                    var files = getFiles(e.dataTransfer.files, accept);
                    props.onDragFiles && props.onDragFiles(multiple ? files : files.slice(0, 1));
                }
                props.onDrop && props.onDrop(e);
            }
        }, onDragOver: function (e) {
            var _a;
            e.preventDefault();
            if (!disabled && !isDragging) {
                setIsDragging(true);
                (_a = props.onDragOver) === null || _a === void 0 ? void 0 : _a.call(props, e);
            }
        } }), react.isValidElement(children) ? (react.createElement("div", { className: (0,classNames/* default */.Z)((_a = {}, _a[prefixCls + "-trigger-custom-active"] = isDragging, _a)) }, react.cloneElement(children, nodeProps))) : listType === 'picture-card' ? (react.createElement("div", { className: prefixCls + "-trigger-picture-wrapper" },
        react.createElement("div", { className: prefixCls + "-trigger-picture", tabIndex: 0, "aria-label": locale.Upload.upload },
            react.createElement("div", { className: prefixCls + "-trigger-picture-text" },
                react.createElement(IconPlus/* default */.Z, null))))) : drag ? (react.createElement("div", { className: (0,classNames/* default */.Z)(prefixCls + "-trigger-drag", (_b = {},
            _b[prefixCls + "-trigger-drag-active"] = isDragging,
            _b)), tabIndex: 0, "aria-label": locale.Upload.drag },
        react.createElement(IconPlus/* default */.Z, null),
        react.createElement("p", { className: prefixCls + "-trigger-drag-text" }, isDragging ? locale.Upload.dragHover : locale.Upload.drag),
        tip && react.createElement("div", { className: prefixCls + "-trigger-tip" }, tip))) : (react.createElement(Button/* default */.Z, trigger_node_assign({}, nodeProps, { "aria-label": locale.Upload.upload, type: "primary", className: prefixCls + "-trigger-with-icon" }),
        react.createElement(IconUpload/* default */.Z, null),
        locale.Upload.upload))));
};
/* harmony default export */ var trigger_node = (TriggerNode);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/uploader.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var uploader_assign = (undefined && undefined.__assign) || function () {
    uploader_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return uploader_assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var Uploader = /** @class */ (function (_super) {
    __extends(Uploader, _super);
    function Uploader(props) {
        var _this = _super.call(this, props) || this;
        // 提供 ref 调用
        _this.upload = function (file) {
            _this.doUpload(file);
        };
        // 提供 ref 调用。终止
        _this.abort = function (file) {
            var req = _this.state.uploadRequests[file.uid];
            if (req) {
                req.abort && req.abort();
                _this.updateFileStatus(uploader_assign(uploader_assign({}, file), { status: STATUS.fail }));
                _this.deleteReq(file.uid);
            }
        };
        // 重新上传 。提供 ref 调用
        _this.reupload = function (file) {
            _this.doUpload(uploader_assign(uploader_assign({}, file), { percent: 0, status: STATUS.uploading }));
        };
        _this.deleteReq = function (uid) {
            var newValue = uploader_assign({}, _this.state.uploadRequests);
            delete newValue[uid];
            _this.setState({
                uploadRequests: newValue,
            });
        };
        // 提供 ref 调用
        // 删除上传（手动上传时，文件会出现在上传列表，但属于init状态）
        _this.delete = _this.deleteReq;
        _this.updateFileStatus = function (file, fileList) {
            if (fileList === void 0) { fileList = _this.props.fileList; }
            var onFileStatusChange = _this.props.onFileStatusChange;
            var key = 'uid' in file ? 'uid' : 'name';
            onFileStatusChange &&
                onFileStatusChange(fileList.map(function (item) {
                    return item[key] === file[key] ? file : item;
                }), file);
        };
        _this.getTargetFile = function (file) {
            var key = 'uid' in file ? 'uid' : 'name';
            var targetFile = _this.props.fileList.find(function (item) { return item[key] === file[key]; });
            return targetFile;
        };
        // 执行上传
        _this.doUpload = function (file) { return __awaiter(_this, void 0, void 0, function () {
            var _a, action, headers, name, data, withCredentials, customRequest, method, onProgress, onSuccess, onError, options, request;
            var _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, action = _a.action, headers = _a.headers, name = _a.name, data = _a.data, withCredentials = _a.withCredentials, customRequest = _a.customRequest, method = _a.method;
                        onProgress = function (percent, event) {
                            var targetFile = _this.getTargetFile(file);
                            if (targetFile) {
                                targetFile.status = STATUS.uploading;
                                targetFile.percent = percent;
                                _this.props.onProgress && _this.props.onProgress(targetFile, event);
                            }
                        };
                        onSuccess = function (response) {
                            var targetFile = _this.getTargetFile(file);
                            if (targetFile) {
                                targetFile.status = STATUS.success;
                                // 传入的响应将会作为 response 字段被附加到上传列表中对应的文件
                                targetFile.response = response;
                                _this.updateFileStatus(targetFile);
                            }
                            _this.deleteReq(file.uid);
                        };
                        onError = function (response) {
                            var targetFile = _this.getTargetFile(file);
                            if (targetFile) {
                                targetFile.status = STATUS.fail;
                                // 传入的响应将会作为 response 字段被附加到上传列表中对应的文件
                                targetFile.response = response;
                                _this.updateFileStatus(targetFile);
                            }
                            _this.deleteReq(file.uid);
                        };
                        options = {
                            onProgress: onProgress,
                            onSuccess: onSuccess,
                            onError: onError,
                            headers: headers,
                            name: name,
                            file: file.originFile,
                            data: data,
                            withCredentials: withCredentials,
                        };
                        // 更新上传状态
                        this.updateFileStatus(file);
                        if (!action) return [3 /*break*/, 1];
                        request = Upload_request(uploader_assign(uploader_assign({}, options), { action: action, method: method }));
                        return [3 /*break*/, 3];
                    case 1:
                        if (!customRequest) return [3 /*break*/, 3];
                        return [4 /*yield*/, customRequest(options)];
                    case 2:
                        request = _c.sent();
                        _c.label = 3;
                    case 3:
                        this.setState({
                            uploadRequests: uploader_assign(uploader_assign({}, this.state.uploadRequests), (_b = {}, _b[file.uid] = request, _b)),
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleFiles = function (files) {
            var _a = _this.props, limit = _a.limit, fileList = _a.fileList, onExceedLimit = _a.onExceedLimit, autoUpload = _a.autoUpload;
            if ((0,is/* isNumber */.hj)(limit) && limit < fileList.length + files.length) {
                return onExceedLimit && onExceedLimit(files, fileList);
            }
            var list = _this.props.fileList || [];
            var asyncUpload = function (file, index) {
                var upload = {
                    uid: "" + String(+new Date()) + index,
                    originFile: file,
                    percent: 0,
                    status: STATUS.init,
                    name: file.name,
                };
                list.push(upload);
                // 更新上传状态为 init
                _this.updateFileStatus(upload, list);
                if (autoUpload) {
                    /**
                     * 需要setTimeout，否则一次上传较多文件时，可能出现第i个文件和第i+1个文件同时更新上传列表中的状态，
                     * 状态被相互覆盖的情况。
                     */
                    setTimeout(function () {
                        _this.doUpload(uploader_assign(uploader_assign({}, upload), { status: STATUS.uploading }));
                    }, 0);
                }
            };
            files.forEach(function (file, index) {
                if (isAcceptFile(file, _this.props.accept)) {
                    // windows can upload file type not in accept bug
                    if ((0,is/* isFunction */.mf)(_this.props.beforeUpload)) {
                        // 只有在beforeUpload返回值 === false 时，取消上传操作
                        Promise.resolve(_this.props.beforeUpload(file, files))
                            .then(function (val) {
                            if (val !== false) {
                                var newFile = (0,is/* isFile */.zE)(val) ? val : file;
                                asyncUpload(newFile, index);
                            }
                        })
                            .catch(function (e) {
                            console.error(e);
                        });
                    }
                    else {
                        asyncUpload(file, index);
                    }
                }
            });
        };
        _this.state = {
            uploadRequests: {},
        };
        return _this;
    }
    Uploader.prototype.render = function () {
        var _this = this;
        var _a = this.props, accept = _a.accept, multiple = _a.multiple, children = _a.children, prefixCls = _a.prefixCls, tip = _a.tip, disabled = _a.disabled, drag = _a.drag, listType = _a.listType, hide = _a.hide, directory = _a.directory, onDrop = _a.onDrop, onDragOver = _a.onDragOver, onDragLeave = _a.onDragLeave;
        return (react.createElement(react.Fragment, null,
            react.createElement("input", uploader_assign({ key: "trigger-input", ref: function (node) { return (_this.inputRef = node); }, style: { display: 'none' }, type: "file", accept: (0,is/* isObject */.Kn)(accept) ? accept === null || accept === void 0 ? void 0 : accept.type : accept, multiple: multiple }, (directory ? { webkitdirectory: 'true' } : {}), { onChange: function (e) {
                    var files = e.target.files;
                    if (files) {
                        _this.handleFiles([].slice.call(files));
                        _this.inputRef.value = '';
                    }
                }, onClick: function (e) {
                    e.stopPropagation();
                } })),
            react.createElement(CSSTransition/* default */.Z, { key: "trigger-node", in: !hide, timeout: 100, unmountOnExit: true, classNames: "fadeIn" },
                react.createElement(trigger_node, { directory: directory, tip: tip, multiple: multiple, accept: accept, disabled: disabled, drag: drag, listType: listType, onDrop: onDrop, onDragOver: onDragOver, onDragLeave: onDragLeave, onDragFiles: this.handleFiles, onClick: function () {
                        !disabled && _this.inputRef && _this.inputRef.click();
                    }, prefixCls: prefixCls }, (0,is/* isFunction */.mf)(children) ? children({ fileList: this.props.fileList }) : children)),
            tip && listType !== 'picture-card' && !drag ? (react.createElement("div", { key: "trigger-tip", className: prefixCls + "-trigger-tip" }, tip)) : null));
    };
    return Uploader;
}(react.Component));
/* harmony default export */ var uploader = (Uploader);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/warning.js
var warning = __webpack_require__(97802);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/upload.js
var upload_assign = (undefined && undefined.__assign) || function () {
    upload_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return upload_assign.apply(this, arguments);
};
var upload_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var upload_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};










var processFile = function (fileList) {
    var files = [].concat(fileList || []).filter(Boolean);
    return files.reduce(function (total, file, index) {
        if (file.uid) {
            var repeatUidIndex = files.findIndex(function (item) { return file.uid === item.uid && file !== item; });
            (0,warning/* default */.Z)(repeatUidIndex !== -1, '[Upload]: duplicate uid');
            var item = upload_assign({ status: STATUS.success, percent: 100 }, file);
            if (repeatUidIndex === -1) {
                total.push(item);
            }
            else {
                // TODO: remove splice logic.
                // 这里是为了兼容以前 uid 出现重复时，会以最后传入的 file 为主的逻辑。p.s: Use bugs as feature
                total.splice(repeatUidIndex, 1, item);
            }
        }
        else {
            (0,warning/* default */.Z)(true, '[Upload]: uid is required');
            var uid = "" + String(+new Date()) + index;
            total.push(upload_assign({ uid: uid, status: STATUS.success, percent: 100 }, file));
        }
        return total;
    }, []);
};
var defaultProps = {
    listType: 'text',
    autoUpload: true,
    showUploadList: true,
    beforeUpload: function () { return true; },
    method: 'post',
};
var Upload = function (baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Upload);
    var prefixCls = getPrefixCls('upload');
    var uploaderRef = (0,react.useRef)();
    var _c = upload_read((0,react.useState)(function () {
        return 'fileList' in props
            ? processFile(props.fileList)
            : 'defaultFileList' in props
                ? processFile(props.defaultFileList)
                : [];
    }), 2), innerUploadState = _c[0], setInnerUploadState = _c[1];
    var mergeFileList = 'fileList' in props ? processFile(props.fileList) : innerUploadState;
    var tryUpdateUploadList = function (fileList, file) {
        var _a;
        if (!('fileList' in props)) {
            setInnerUploadState(fileList);
        }
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, fileList, file);
    };
    var uploadFile = function (file) {
        file &&
            setTimeout(function () {
                uploaderRef.current && uploaderRef.current.upload(file);
            }, 0);
    };
    // 重新上传
    var reuploadFile = function (file) {
        uploaderRef.current && uploaderRef.current.reupload(file);
        props.onReupload && props.onReupload(file);
    };
    // 移除文件，如果正在上传，终止上传
    var removeFile = function (file) {
        if (file) {
            var onRemove = props.onRemove;
            Promise.resolve((0,is/* isFunction */.mf)(onRemove) ? onRemove(file, mergeFileList) : onRemove)
                .then(function (val) {
                if (val !== false) {
                    uploaderRef.current && uploaderRef.current.abort(file);
                    tryUpdateUploadList(mergeFileList.filter(function (x) { return x.uid !== file.uid; }), file);
                }
            })
                .catch(function (e) {
                console.error(e);
            });
        }
    };
    // 中止文件上传
    var abortFile = function (file) {
        if (file) {
            uploaderRef.current && uploaderRef.current.abort(file);
        }
    };
    (0,react.useImperativeHandle)(ref, function () {
        return {
            submit: function (file) {
                var list = [];
                if (file) {
                    list = [file];
                }
                else {
                    list = mergeFileList.filter(function (x) { return x.status === STATUS.init; });
                }
                list.forEach(function (x) {
                    uploadFile(x);
                });
            },
            // file: fileList中的file对象
            abort: function (file) {
                abortFile(file);
            },
            // file: fileList中的file对象
            reupload: function (file) {
                reuploadFile(file);
            },
        };
    });
    var listType = props.listType, className = props.className, style = props.style, renderUploadItem = props.renderUploadItem, showUploadList = props.showUploadList, renderUploadList = props.renderUploadList, progressProps = props.progressProps, imagePreview = props.imagePreview, rest = upload_rest(props, ["listType", "className", "style", "renderUploadItem", "showUploadList", "renderUploadList", "progressProps", "imagePreview"]);
    // const fileList = getFileList(uploadState.current);
    var limit = (0,is/* isNumber */.hj)(props.limit)
        ? { hideOnExceedLimit: true, maxCount: props.limit }
        : upload_assign({ hideOnExceedLimit: true }, props.limit);
    var exceedLimit = limit.maxCount && limit.maxCount <= mergeFileList.length;
    var disabledUploadDom = 'disabled' in props ? props.disabled : !limit.hideOnExceedLimit && exceedLimit;
    var uploadDom = (react.createElement("div", upload_assign({}, (0,omit/* default */.Z)(rest, [
        'disabled',
        'directory',
        'onReupload',
        'defaultFileList',
        'fileList',
        'autoUpload',
        'error',
        'action',
        'method',
        'multiple',
        'name',
        'accept',
        'customRequest',
        'children',
        'autoUpload',
        'limit',
        'drag',
        'tip',
        'headers',
        'data',
        'withCredentials',
        'onChange',
        'onPreview',
        'onRemove',
        'onProgress',
        'onExceedLimit',
        'beforeUpload',
        'onDrop',
        'onDragOver',
        'onDragLeave',
    ]), { className: (0,classNames/* default */.Z)(prefixCls, (_a = {},
            _a[prefixCls + "-type-" + listType] = listType,
            _a[prefixCls + "-drag"] = props.drag,
            _a[prefixCls + "-disabled"] = disabledUploadDom,
            _a[prefixCls + "-hide"] = limit.hideOnExceedLimit && exceedLimit,
            _a[prefixCls + "-rtl"] = rtl,
            _a), className), style: style }),
        react.createElement(uploader, upload_assign({ ref: uploaderRef }, props, { limit: limit.maxCount, hide: limit.hideOnExceedLimit && exceedLimit, disabled: disabledUploadDom, prefixCls: prefixCls, fileList: mergeFileList, onProgress: function (file, e) {
                if (file) {
                    if (!('fileList' in props)) {
                        setInnerUploadState(mergeFileList.map(function (item) {
                            return item.uid === file.uid ? file : item;
                        }));
                    }
                    props.onProgress && props.onProgress(file, e);
                }
            }, onFileStatusChange: tryUpdateUploadList }))));
    return (react.createElement(react.Fragment, null,
        listType !== 'picture-card' && uploadDom,
        showUploadList && (react.createElement(list, { imagePreview: imagePreview, progressProps: progressProps, showUploadList: showUploadList, disabled: props.disabled, listType: listType, fileList: mergeFileList, renderUploadItem: renderUploadItem, renderUploadList: renderUploadList, onUpload: uploadFile, onAbort: abortFile, onRemove: removeFile, onReupload: reuploadFile, onPreview: props.onPreview, prefixCls: prefixCls })),
        listType === 'picture-card' && uploadDom,
        props.tip && listType === 'picture-card' && (react.createElement("div", { className: prefixCls + "-trigger-tip" }, props.tip))));
};
var UploadRef = (0,react.forwardRef)(Upload);
UploadRef.displayName = 'Upload';
/* harmony default export */ var upload = (UploadRef);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Upload/index.js

/* harmony default export */ var es_Upload = (upload);


/***/ })

}]);